module.exports = {
      id: "print-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/icons.a0c47b73.svg#print-usage",
      toString: function () {
        return this.url;
      }
    }